// SPDX-License-Identifier: Elastic-2.0
/**
 * Route path constants (T-004).
 *
 * Single source of truth for in-app route paths. Avoid hard-coding
 * route strings in `<Link>` / `navigate()` callsites — import from here
 * so renames stay safe.
 *
 * (Historical: a `/ha` Advanced-mode path was once reachable via an external
 * link; it was removed in F-357 / ADR-010 — no Home Assistant UI ships.)
 */
export const ROUTES = {
  ROOT: "/",
  ONBOARDING: "/onboarding",
  ONBOARDING_ACCOUNT: "/onboarding/account",
  // F-613: stub forgot-password page reached from the cloud sign-in form.
  // Public (guard-free) sibling of ONBOARDING_ACCOUNT; the full reset
  // email flow is a separate feature.
  FORGOT_PASSWORD: "/account/forgot-password",
  DASHBOARD: "/dashboard",
  ROUTINES: "/routines",
  NEW_ROUTINE: "/routines/new",
  SUGGESTIONS: "/suggestions",
  SETTINGS: "/settings",
  OFFLINE: "/offline",
  // F-330 additions — placeholder routes for the new sidebar IA.
  DEVICES: "/devices",
  ACCOUNT: "/account",
  PLAN: "/plan",
  REMOTE_ACCESS: "/remote-access",
  BACKUPS: "/backups",
  VOICE: "/voice",
  HOMES: "/homes",
  API_KEYS: "/api-keys",
  MARKETPLACE: "/marketplace",
  PUBLISH: "/publish",
  ANALYTICS: "/analytics",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
